import api from "../../../../service/api";
import routes from "../../../../service/apiRoutes";

export const listUsers = (id) => api.get(`${routes.listUsers}?client_id=${id}`)
export const addUserToClient = (data) => api.post(routes.clientUser, data)
